import { useMemo } from 'react';
import { Source, Layer } from 'react-map-gl';
import { useAtomValue } from 'jotai';

import { aoiPolygonAtoms } from './inventory-surface/map-atoms';
import { useSurface } from './inventory-surface/surface';

export const TcAoiPolygonLayer = () => {
  const polygon = useAtomValue(aoiPolygonAtoms[useSurface()]);

  const geojson = useMemo((): GeoJSON.FeatureCollection | null => {
    if (!polygon) return null;
    return {
      type: 'FeatureCollection',
      features: [{ type: 'Feature', geometry: polygon, properties: {} }],
    };
  }, [polygon]);

  if (!geojson) return null;

  return (
    <Source id="tc-aoi-polygon-static" type="geojson" data={geojson}>
      <Layer
        id="tc-aoi-polygon-outline"
        type="line"
        paint={{ 'line-color': '#1d891e', 'line-width': 3 }}
      />
    </Source>
  );
};
